import { Flex, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { ThreeDots } from "react-loader-spinner";

export default function Spinner() {
  return (
    <Flex>
      <ThreeDots color="brand.500" height={40} width={40} ariaLabel="loading" />
    </Flex>
  );
}

const loadingAnimation = keyframes`
  0%, 80%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
`;

export const LoadingText = () => (
  <Text fontSize="lg" color="gray.600" fontWeight="medium">
    សូមរង់ចាំ
    <Text as="span" animation={`${loadingAnimation} 1.4s infinite ease-in-out`} ml={1}>
      .
    </Text>
    <Text as="span" animation={`${loadingAnimation} 1.4s infinite ease-in-out 0.2s`} ml={0}>
      .
    </Text>
    <Text as="span" animation={`${loadingAnimation} 1.4s infinite ease-in-out 0.4s`} ml={0}>
      .
    </Text>
  </Text>
);
